import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

export const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    setIsMobileMenuOpen(false);
    const el = document.getElementById(sectionId);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
      isScrolled ? 'bg-black/95 shadow-lg' : 'bg-transparent'
    }`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo - hidden on Hero (top), appears once scrolled past Hero */}
          <div className={`flex-shrink-0 transition-opacity duration-300 ${isScrolled ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <img
              src="https://tafworldwide.b-cdn.net/2026%20TAFWORLDWIDE%20PNG.png"
              alt="TAF WORLDWIDE"
              className="h-10 md:h-12 w-auto max-w-[130px] md:max-w-[180px] object-contain"
              data-testid="navbar-logo"
            />
          </div>

          {/* Desktop Menu */}
          <div className="hidden md:flex items-center space-x-8">
            <button onClick={() => scrollToSection('home')}      className="nav-link">Home</button>
            <button onClick={() => scrollToSection('about')}     className="nav-link">About</button>
            <button onClick={() => scrollToSection('services')}  className="nav-link">Services</button>
            <button onClick={() => scrollToSection('portfolio')} className="nav-link">Portfolio</button>
            <button onClick={() => scrollToSection('contact')}   className="nav-link">Contact</button>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-white hover:text-orange-400 transition-colors p-2"
              data-testid="navbar-mobile-menu-toggle"
              aria-label="Toggle mobile menu"
            >
              {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="md:hidden bg-black/98 backdrop-blur-lg border-t border-white/10" data-testid="navbar-mobile-menu">
          <div className="px-4 py-6 space-y-4">
            <button onClick={() => scrollToSection('home')}      className="mobile-nav-link">Home</button>
            <button onClick={() => scrollToSection('about')}     className="mobile-nav-link">About</button>
            <button onClick={() => scrollToSection('services')}  className="mobile-nav-link">Services</button>
            <button onClick={() => scrollToSection('portfolio')} className="mobile-nav-link">Portfolio</button>
            <button onClick={() => scrollToSection('contact')}   className="mobile-nav-link">Contact</button>
          </div>
        </div>
      )}
    </nav>
  );
};
